module.exports = __webpack_public_path__ + "f52f45391717491133315c07bec3da85.svg";